import { ReactNode, memo, useMemo } from 'react'
import { useTranslation } from '@crew/modules/i18n'
import BaselineDelete from '~icons/ic/baseline-delete'
import BaselineCreate from '~icons/ic/baseline-create'
import { CrewBadge } from 'components/elements/crewBadge/crewBadge'
import { useUserSetting } from '@crew/states'
import { Region, SettingKeyType } from '@crew/enums/app'

type TaskState = {
  name: string
  taskStateType: string
  displayColor: string
  createdAt: string
}

type TaskStateListItemProps = {
  taskState: TaskState
  isVisibleDeleteButton: boolean
  onEditButtonClick: () => void
  onDeleteButtonClick: () => void
  dragHandle: ReactNode
}

export const TaskStateListItem = memo((props: TaskStateListItemProps) => {
  const { t } = useTranslation()

  // ユーザー設定からデフォルトのユーザープロファイル地域を取得
  const defaultUserProfileRegion = useUserSetting(
    SettingKeyType.UserProfileRegion,
    Region.Japan.value
  )

  // 名称
  const renderNameCell = useMemo(() => {
    return (
      <CrewBadge displayColor={props.taskState.displayColor}>
        {props.taskState.name}
      </CrewBadge>
    )
  }, [props.taskState.name, props.taskState.displayColor])

  // タイプ
  const renderTaskStateTypeCell = useMemo(
    () => t(`label.${props.taskState.taskStateType}`),
    [t, props.taskState.taskStateType]
  )

  // 登録日時
  const renderRegisteredDateCell = useMemo(
    () =>
      t('format.timestamp', {
        value: props.taskState.createdAt,
        timeZone: defaultUserProfileRegion,
      }),
    [t, props.taskState.createdAt, defaultUserProfileRegion]
  )

  return (
    <>
      {/* drag handle item */}
      <td>{props.dragHandle}</td>

      {/* Task state name */}
      <td className="w-2/12 max-w-0">{renderNameCell}</td>

      {/* Task state type */}
      <td className="w-2/12">{renderTaskStateTypeCell}</td>

      {/* Task state registered date */}
      <td className="w-4/12">{renderRegisteredDateCell}</td>

      {/* Action button */}
      <td className="w-3/12">
        <div className="flex gap-2 pr-2 justify-end items-center">
          <span className="cursor-pointer" onClick={props.onEditButtonClick}>
            <BaselineCreate width={24} height={24} />
          </span>
          {props.isVisibleDeleteButton && (
            <span
              className="cursor-pointer"
              onClick={props.onDeleteButtonClick}
            >
              <BaselineDelete width={24} height={24} />
            </span>
          )}
        </div>
      </td>
    </>
  )
})
